import { RadioGroup } from '@/libs/components/src/lib/form/RadioGroup';
import { Input } from '@chiroup/components/form/Input';
import { QuestionAnswer } from '@chiroup/core/types/ComplaintSummary.type';
import React from 'react';

interface HCRadioButtonProps {
  questionId: string;
  questionData: QuestionAnswer;
  onAnswerChange: (questionId: string, newValue: string | string[], otherValue?: string) => void;
}

const HCRadioButton: React.FC<HCRadioButtonProps> = ({
  questionId,
  questionData,
  onAnswerChange,
}) => {
  const { options = [], selectedValues = [], otherValue } = questionData;

  // Check if any option has id 'other' to enable the includeOther prop
  const hasOtherOption = options.some(opt => opt.id === 'other');

  // Filter out the 'other' option from regular options since we handle it separately
  const regularOptions = options.filter(opt => opt.id !== 'other');

  const hasSelectedOther = selectedValues.includes('other');

  // Convert options to RadioGroup format
  const radioOptions = regularOptions.map(option => ({
    value: option.id,
    text: option.display,
  }));

  if (hasOtherOption) {
    radioOptions.push({
      value: 'other',
      text: 'Other',
    });
  }

  return (
    <div className="max-w-xs">
      <RadioGroup
        name={questionId}
        options={radioOptions}
        value={selectedValues[0]}
        onChange={value => onAnswerChange(questionId, [value])}
      />
      {hasSelectedOther && (
        <Input
          name={`edit-${questionId}-other`}
          type="text"
          value={otherValue || ''}
          onChange={value => onAnswerChange(questionId, selectedValues, value)}
          className="w-48 primary mt-2"
        />
      )}
    </div>
  );
};

export default HCRadioButton;
